import React, {Component} from 'react';
import validate from './validation';
import {Grid} from 'material-ui';
import {Field, reduxForm} from 'redux-form';
import {InputTextField} from '../../../components/fields/field_input_text';
import {InputSelectField} from '../../../components/fields/field_input_select_menus';
import {Heading} from '../../../components/heading/heading';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';

class RedirectEditForm extends Component {
    render() {
        const {
            statuses,
            sites,
            handleSubmit,
            pristine,
            touched,
            classes,
            loading,
            redirect,
        } = this.props;

        let isRedirectToRequired = true;
        if (redirect && redirect.status === 410) {
            isRedirectToRequired = false;
        }

        return (
            <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                <Heading title={'Edit Redirect'} />
                <Grid container id="text-fields">
                    <Grid item xs={12}>
                        <Field
                            name="redirect_from"
                            component={InputTextField}
                            label="Redirect From"
                            fullWidth={true}
                            helperText="e.g. /teaching/"
                            InputLabelProps={{
                                required: true,
                            }}
                        />
                        <Field
                            name="redirect_to"
                            component={InputTextField}
                            label="Redirect To"
                            fullWidth={true}
                            helperText="e.g. /volunteer-teaching/"
                            InputLabelProps={{
                                required: isRedirectToRequired,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container id="select-fields">
                    <Grid item xs={12} md={4}>
                        <Field
                            className={classes.selectMenuItem}
                            id="select-site"
                            name="site_id"
                            component={InputSelectField}
                            label="Select Website"
                            options={sites}
                            fullWidth={true}
                            InputLabelProps={{
                                required: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Field
                            className={classes.selectMenuItem}
                            id="select-status"
                            name="status"
                            component={InputSelectField}
                            label="Select Status Code"
                            options={statuses}
                            fullWidth={true}
                            InputLabelProps={{
                                required: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={(!touched && pristine) || loading}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                        />
                        <BackButton
                            link={'/redirects'}
                            style={{marginRight: 15}}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default reduxForm({
    form: 'RedirectEditForm',
    enableReinitialize: true,
    destroyOnUnmount: false,
    validate,
})(RedirectEditForm);



// WEBPACK FOOTER //
// ./src/containers/redirects/forms/EditRedirectForm.jsx